(function () {

  var product_table_container,
    product_table_container_wrapper,
    table_fixed_header,
    scroll_swipe;

  function update() {
    requestAnimationFrame(productTableContainerOnScroll);
  }

  function productTableContainerOnScroll() {
    var bounds = product_table_container.getBoundingClientRect(),
      scroll_swipe_top = 0;
    table_fixed_header.style.marginLeft = -product_table_container.scrollLeft + 'px';

    scroll_swipe.style.transform = 'unset';
    if (bounds.top < 107 && bounds.top + bounds.height > 0) {
      product_table_container_wrapper.style.transform = 'unset';
      product_table_container_wrapper.style.visibility = '';
      var product_table_container_wrapper_bounds = product_table_container_wrapper.getBoundingClientRect();

      product_table_container_wrapper.style.transform = 'translateY(' + -product_table_container_wrapper_bounds.top + 'px)';
      scroll_swipe_top = -scroll_swipe.getBoundingClientRect().top + 160;
    } else {
      product_table_container_wrapper.style.visibility = 'hidden';
    }
    if (bounds.height - scroll_swipe_top < 160) {
      scroll_swipe.style.visibility = 'hidden';
    } else {
      scroll_swipe.style.visibility = '';
      scroll_swipe.style.transform = 'translateY(' + scroll_swipe_top + 'px)';
    }

    // First cell shoud not scroll sideways.
    var th = table_fixed_header.querySelector('th:first-child');
    th.style.transform = 'translateX(' + product_table_container.scrollLeft + 'px)';
  }

  window.addEventListener('load', function () {
    product_table_container = document.querySelector('.product-table-container');

    if (!product_table_container) {
      return;
    }

    scroll_swipe = product_table_container.parentNode.querySelector('.scroll-swipe');

    // Clone the table.
    table_fixed_header = product_table_container.cloneNode(true);
    table_fixed_header.classList.add('table-fixed-header');

    product_table_container_wrapper = document.createElement('div');
    product_table_container_wrapper.classList.add('product-table-container-wrapper');
    product_table_container_wrapper.appendChild(table_fixed_header);
    product_table_container.parentNode.appendChild(product_table_container_wrapper);

    // Set fixed th widths
    table_fixed_header.querySelectorAll('th').forEach(function (th) {
      th.style.width = th.getBoundingClientRect().width + 'px';
    });

    var tbody = table_fixed_header.querySelector('tbody');
    tbody.parentNode.removeChild(tbody);

    update();
    window.addEventListener('resize', update);
    product_table_container.addEventListener('scroll', update);
    window.addEventListener('scroll', update);
  });

})();